// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vHOm","rootMobile":"styles_rootMobile__2yc3e"};